import { render, staticRenderFns } from "./preStartupImprOld.vue?vue&type=template&id=6f2f0dd0"
import script from "./preStartupImprOld.vue?vue&type=script&lang=js"
export * from "./preStartupImprOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2f0dd0')) {
      api.createRecord('6f2f0dd0', component.options)
    } else {
      api.reload('6f2f0dd0', component.options)
    }
    module.hot.accept("./preStartupImprOld.vue?vue&type=template&id=6f2f0dd0", function () {
      api.rerender('6f2f0dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/psr/preStartupImprOld.vue"
export default component.exports